const GA_ENDPOINT = "https://www.google-analytics.com/mp/collect";
const REDIRECT_DELAY_MS = 150;
const GA_MEASUREMENT_ID = "G-WXZQ92TM53";

const getEnvValue = (publicKey, fallbackKey) => {
  const publicValue = process.env[publicKey];
  const fallbackValue = process.env[fallbackKey];

  return publicValue || fallbackValue || "";
};

const getMeasurementUrl = () => {
  const measurementId =
    GA_MEASUREMENT_ID ||
    getEnvValue("REACT_APP_GA_MEASUREMENT_ID", "GA_MEASUREMENT_ID");
  const apiSecret = getEnvValue("REACT_APP_GA_API_SECRET", "GA_API_SECRET");

  if (!measurementId || !apiSecret) {
    return null;
  }

  const searchParams = new URLSearchParams({
    measurement_id: measurementId,
    api_secret: apiSecret,
  });

  return `${GA_ENDPOINT}?${searchParams.toString()}`;
};

const createClientId = () => {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  return `${Date.now()}.${Math.random().toString(16).slice(2)}`;
};

export const sendGAEvent = async (slug, campaign, destination) => {
  const url = getMeasurementUrl();

  if (!url) {
    return;
  }

  const payload = {
    client_id: createClientId(),
    events: [
      {
        name: "qr_scan",
        params: {
          slug,
          destination,
          campaign: campaign || "unknown",
          engagement_time_msec: 1,
        },
      },
    ],
  };

  try {
    await fetch(url, {
      method: "POST",
      mode: "no-cors",
      cache: "no-store",
      keepalive: true,
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
  } catch (error) {
    console.error("GA4 redirect event failed:", error);
  }
};

export const redirectAfterTracking = async (slug, campaign, destination) => {
  await Promise.race([
    sendGAEvent(slug, campaign, destination),
    new Promise((resolve) => {
      window.setTimeout(resolve, REDIRECT_DELAY_MS);
    }),
  ]);

  window.location.replace(destination);
};
